
import React from "react"
import Logout from "../components/Logout"
import FullWidthTabs from '../components/SiteTabs'


const Dashboard = () => {
  return (
    <>
      <Logout />
      <h1 style={{textAlign:"center"}} >Online Monitor Dashboard</h1>
      <FullWidthTabs />
    </>

  )
}
export default Dashboard
